import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import Header from '../Global/Header';
import Subcategory from './Subcategory';

const Category = (props) => {

    const [anim, setAnim] = useState(true)
    const [state, setState] = useState({
        data: null
    })

    useEffect(() => {

        setAnim(true)
        const data = JSON.parse(localStorage.getItem('category'))
        setTimeout(() => {
            setAnim(false)
            setState({
                ...state,
                data: data[props.match.params.pg]
            })
        }, 500);
        // console.log(JSON.parse(localStorage.getItem('category')))

    }, [props.match.params.pg])

    const handleChangeCategory = (info) => {
        const params = parseInt(props.match.params.pg) + 1;
        const mainData = {
            ...JSON.parse(localStorage.getItem('category')),
            [params]: { ...info }
        }
        localStorage.setItem('category', JSON.stringify(mainData));
        if (info.children.length == 0) {
            props.history.push(`/Education/content/${info.id}`)
        } else {
            props.history.push(`/Education/category/${params}`)
        }
    }

    return (
        <div className="instructpg category-educ">
            <Header
                innerPage={true}
                title={state.data !== null ? state.data.subject : ''} />

            <div className={`sub-categorys ${anim ? 'active' : ''}`}>
                {state.data !== null ?
                    state.data.children.length == 0 ?
                        <span className="no-content">اطلاعاتی وجود ندارد</span>
                        :
                        state.data.children.map((info) =>
                            <Subcategory
                                title={info.name}
                                handleClick={() => handleChangeCategory(info)} />
                        )
                    :
                    null
                }
            </div>

        </div>
    );
}

export default withRouter(Category);